export default "__VITE_ASSET__Dir$UL5Y__"